import { useMutation, useQuery } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";

interface IDeleteSectorRequest {
    id: number;
}

async function deleteSector(data: IDeleteSectorRequest): Promise<BaseResponse<any>> {
    try {
        const response = await axiosInstance.post("/Merchant/DeleteSector?id=" + data.id, {});
        return response.data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useDeleteSector(data: IDeleteSectorRequest) {
    return useMutation<any | undefined, Error, IDeleteSectorRequest>(
        (data) => deleteSector(data)
    );
}